<template>
	<div>
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'products',
	};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/products/products.vue